// extracted by mini-css-extract-plugin
export default {"all":"period-select_all__+1+DN"};